import { render, staticRenderFns } from "./RTDispersion.vue?vue&type=template&id=6dff248a&scoped=true"
import script from "./RTDispersion.vue?vue&type=script&lang=js"
export * from "./RTDispersion.vue?vue&type=script&lang=js"
import style0 from "./RTDispersion.vue?vue&type=style&index=0&id=6dff248a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff248a",
  null
  
)

export default component.exports